import { combineReducers } from 'redux';
import vehicles from './vehicles';
import exportVehicles from './export';

export default combineReducers({
    vehicles,
    exportVehicles
});
